export const ACTION_TYPES = {
  VIEW_USER: 'viewUser',
  EDIT_USER: 'editUser',
  DELETE_USER: 'deleteUser',
  RESTORE_USER: 'restoreUser',
  ACTIVE_USERS: 'activeUsers',
  CREATE_USER: 'createUser',
  DELETED_USERS: 'deletedUsers',
} as const;
